<div class="apps-dialog pt-4">
  <!-- Header -->
  <div class="flex items-center justify-between mb-6">
    <div class="flex items-center space-x-3">
      <div
        class="w-8 h-8 bg-gradient-to-br from-primary-500 to-primary-600 rounded-lg flex items-center justify-center"
      >
        <i class="pi pi-th-large text-white text-sm"></i>
      </div>
      <h3 class="text-xl font-bold text-neutral-950 dark:text-white">{{ 'appsDialog.title' | transloco }}</h3>
    </div>
    <i class="fa-light fa-times cursor-pointer text-neutral-700 hover:text-neutral-800 dark:text-neutral-200 dark:hover:text-neutral-300" (click)="close()"></i>
  </div>

  <!-- Desktop/Tablet Grid View -->
  <div class="hidden sm:block">
    <div class="grid grid-cols-1 gap-4">
      @for (app of apps; track app.id) {
        <button
          (click)="!app.disabled && navigateToApp(app.route)"
          [disabled]="app.disabled"
          [class.opacity-50]="app.disabled"
          [class.cursor-default]="app.disabled"
          class="group flex items-center space-x-4 p-4 rounded-xl hover:bg-gradient-to-r hover:from-primary-50 hover:to-primary-100 dark:hover:from-primary-900/20 dark:hover:to-primary-800/20 transition-all duration-300 border border-transparent hover:border-primary-200 dark:hover:border-primary-700 hover:shadow-lg cursor-pointer disabled:hover:bg-transparent disabled:hover:border-transparent disabled:hover:shadow-none"
        >
          <div
            [class.group-hover:scale-110]="!app.disabled"
            class="min-w-14 h-14 rounded-xl bg-gradient-to-br from-primary-500 to-primary-600 text-white flex items-center justify-center text-2xl font-medium shadow-lg transition-transform duration-300 cursor-pointer"
          >
            {{ app.avatar }}
          </div>
          <div class="flex-1 text-start">
            <h4
              [class.group-hover:text-primary-700]="!app.disabled"
              [class.dark:group-hover:text-primary-300]="!app.disabled"
              class="text-sm font-semibold text-neutral-950 dark:text-white transition-colors duration-300 cursor-pointer"
            >
              {{ app.name }}
            </h4>
            <p class="text-xs text-neutral-500 dark:text-neutral-400 mt-1 cursor-pointer">
              {{ getAppDescription(app.name) | transloco }}
            </p>
          </div>
          @if (!app.disabled) {
            <div
              class="opacity-0 group-hover:opacity-100 transition-opacity duration-300 cursor-pointer"
            >
              <i class="pi pi-arrow-right rtl-flip text-primary-500 text-sm"></i>
            </div>
          }
          @if (app.disabled) {
            <div class="flex items-center space-x-1">
              <span class="text-xs text-neutral-400 dark:text-neutral-500 italic">{{ 'appsDialog.comingSoon' | transloco }}</span>
            </div>
          }
        </button>
      }
    </div>
  </div>

  <!-- Mobile Minimal View -->
  <div class="block sm:hidden">
    <div class="space-y-3">
      @for (app of apps; track app.id) {
        <button
          (click)="!app.disabled && navigateToApp(app.route)"
          [disabled]="app.disabled"
          [class.opacity-50]="app.disabled"
          [class.cursor-default]="app.disabled"
          class="w-full group flex items-center space-x-3 p-3 rounded-lg hover:bg-gradient-to-r hover:from-primary-50 hover:to-primary-100 dark:hover:from-primary-900/20 dark:hover:to-primary-800/20 transition-all duration-300 border border-transparent hover:border-primary-200 dark:hover:border-primary-700 disabled:hover:bg-transparent disabled:hover:border-transparent"
        >
          <div
            [class.group-hover:scale-105]="!app.disabled"
            class="w-10 h-10 rounded-lg bg-gradient-to-br from-primary-500 to-primary-600 text-white flex items-center justify-center text-lg font-medium shadow-md transition-transform duration-300"
          >
            {{ app.avatar }}
          </div>
          <div class="flex-1 text-start min-w-0">
            <h4
              [class.group-hover:text-primary-700]="!app.disabled"
              [class.dark:group-hover:text-primary-300]="!app.disabled"
              class="text-sm font-semibold text-neutral-950 dark:text-white transition-colors duration-300 truncate"
            >
              {{ app.name }}
            </h4>
            <p class="text-xs text-neutral-500 dark:text-neutral-400 mt-0.5 truncate">
              {{ getAppDescription(app.name) | transloco }}
            </p>
          </div>
          @if (!app.disabled) {
            <div class="opacity-0 group-hover:opacity-100 transition-opacity duration-300">
              <i class="pi pi-arrow-right rtl-flip text-primary-500 text-sm"></i>
            </div>
          }
          @if (app.disabled) {
            <div class="flex items-center">
              <span class="text-xs text-neutral-400 dark:text-neutral-500 italic">{{ 'appsDialog.soon' | transloco }}</span>
            </div>
          }
        </button>
      }
    </div>
  </div>
</div>
